import { UserTypeEnum } from "@/enums/UserTypeEnum";
import {BaseModel} from "@/models/base/BaseModel";

export class MaintenanceType extends BaseModel {
  name: string;
  categoryId: string;
  category: string;
  icon: string;
  department: string;
  createdById?: string;
  createdByType?: UserTypeEnum
  updatedById?: string;
  updatedByType?: UserTypeEnum
  deletedById?: string
  deletedByType?: UserTypeEnum
  typesOfRecordChanged?: string[]

  constructor() {
    super()
    this.name = "";
    this.categoryId = "";
    this.category = "";
    this.icon = "";
    this.department = "";
  }
}